// no BaseURI
      // object to store loaded and loading chunks
      // undefined = chunk not loaded, null = chunk preloaded/prefetched
      // [resolve, Promise] = chunk loading, 0 = chunk loaded
      var installedChunks = {"1889": 0,};
      var installChunk = (data) => {
    var __rspack_esm_ids = data.__rspack_esm_ids;
    var __webpack_modules__ = data.__webpack_modules__;
    var __rspack_esm_runtime = data.__rspack_esm_runtime;
    // add "modules" to the modules object,
    // then flag all "ids" as loaded and fire callback
    var moduleId, chunkId, i = 0;
    for (moduleId in __webpack_modules__) {
        if (__webpack_require__.o(__webpack_modules__, moduleId)) {
            __webpack_require__.m[moduleId] = __webpack_modules__[moduleId];
        }
    }
    if (__rspack_esm_runtime) __rspack_esm_runtime(__webpack_require__);
    for (; i < __rspack_esm_ids.length; i++) {
        chunkId = __rspack_esm_ids[i];
        if (__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
            installedChunks[chunkId][0]();
        }
        installedChunks[__rspack_esm_ids[i]] = 0;
    }
    __webpack_require__.O();
};
        __webpack_require__.f.j = function (chunkId, promises) {
          // import() chunk loading for javascript
var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
if (installedChunkData !== 0) { // 0 means "already installed".'
    // a Promise means "currently loading".
    if (installedChunkData) {
        promises.push(installedChunkData[1]);
    } else {
        if (/^(4(632|74|98)|25(30|42)|5(064|459|622)|6(319|671|705|844)|1(107|493|545|796|834|889|961|980)|8(080|626|750)|7(046|224|345|875)|3(2(45|91|95)|104|730|856)|9(7(22|26|30)|396|415))$/.test(chunkId)) {
            // setup Promise in chunk cache
            var promise = import("./" + __webpack_require__.u(chunkId)).then(installChunk, (e) => {
                if (installedChunks[chunkId] !== 0) installedChunks[chunkId] = undefined;
                throw e;
            });
            var promise = Promise.race([promise, new Promise((resolve) => {
                installedChunkData = installedChunks[chunkId] = [resolve];
            })]);
            promises.push(installedChunkData[1] = promise);
        }
        else installedChunks[chunkId] = 0;

    }
}
        }
        
        __webpack_require__.C = installChunk;
        
        __webpack_require__.O.j = function(chunkId) {
            return installedChunks[chunkId] === 0;
        }
        // no HMR
// no HMR manifest
